document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-mt-comparador]').forEach(initComparador);
});

function initComparador(frame) {
  var antesWrap = frame.querySelector('[data-mt-comparador-antes]');
  var manija = frame.querySelector('[data-mt-comparador-manija]');
  if (!antesWrap || !manija) return;

  var arrastrando = false;

  function posicionar(porcentaje) {
    porcentaje = Math.max(0, Math.min(100, porcentaje));
    manija.style.left = porcentaje + '%';
    antesWrap.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
  }

  function porcentajeDesdeEvento(evento) {
    var rect = frame.getBoundingClientRect();
    var x = evento.clientX - rect.left;
    return (x / rect.width) * 100;
  }

  function empezar(evento) {
    arrastrando = true;
    frame.classList.add('mt-comparador-activo');
    mover(evento);
  }

  function mover(evento) {
    if (!arrastrando) return;
    posicionar(porcentajeDesdeEvento(evento));
  }

  function terminar() {
    arrastrando = false;
    frame.classList.remove('mt-comparador-activo');
  }

  frame.addEventListener('pointerdown', function (evento) {
    frame.setPointerCapture(evento.pointerId);
    empezar(evento);
  });
  frame.addEventListener('pointermove', mover);
  frame.addEventListener('pointerup', terminar);
  frame.addEventListener('pointercancel', terminar);

  posicionar(50);
}
